import { Box, Modal, Radio, RadioGroup, FormControlLabel } from '@mui/material'
import React, { useState } from 'react'
import AddOrEditSkillsModal from './AddOrEditSkillsModal'
import '../styles.scss'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import RadioButtonChecked from '../assets/imgs/radio-button-round-checked.svg'
import RadioButtonUnchecked from '../assets/imgs/radio-button-round-unchecked.svg'
import StarIconGolden from '../assets/imgs/star-icon-golden.svg'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const RatingsFilterModal = ({
  ratingsFilterModal = false,
  handleRatingsFilterModal,
  ratingFilterValue,
  setRatingFilterValue,
  ratingDropdownOptions,
  setRatingDropdownOptions,
}) => {

  const [ratingDropdownValue, setRatingDropdownValue] = React.useState(null)

  return (
    <div>
      <Modal
        open={ratingsFilterModal}
        onClose={() => handleRatingsFilterModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="set-skill-rate-modal">
          <div>
            <div>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="five-star"
                name="radio-buttons-group"
                onChange={(e) => {
                  setRatingDropdownOptions(
                    new Array(Number(e.target.value)).fill({}),
                  )
                  handleRatingsFilterModal(false)
                }}
              >
                <FormControlLabel
                  value={5}
                  control={
                    <Radio
                      icon={
                        <img src={RadioButtonUnchecked} height={25} alt="" />
                      }
                      checkedIcon={
                        <img src={RadioButtonChecked} height={25} alt="" />
                      }
                    />
                  }
                  label={
                    <div className="d-flex">
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                    </div>
                  }
                  checked={ratingDropdownOptions?.length === 5}
                />
                <FormControlLabel
                  value={4}
                  control={
                    <Radio
                      icon={
                        <img src={RadioButtonUnchecked} height={25} alt="" />
                      }
                      checkedIcon={
                        <img src={RadioButtonChecked} height={25} alt="" />
                      }
                    />
                  }
                  label={
                    <div className="d-flex">
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                    </div>
                  }
                  checked={ratingDropdownOptions?.length === 4}
                />
                <FormControlLabel
                  value={3}
                  control={
                    <Radio
                      icon={
                        <img src={RadioButtonUnchecked} height={25} alt="" />
                      }
                      checkedIcon={
                        <img src={RadioButtonChecked} height={25} alt="" />
                      }
                    />
                  }
                  label={
                    <div className="d-flex">
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                    </div>
                  }
                  checked={ratingDropdownOptions?.length === 3}
                />
                <FormControlLabel
                  value={2}
                  checked={ratingDropdownOptions?.length === 2}
                  control={
                    <Radio
                      icon={
                        <img src={RadioButtonUnchecked} height={25} alt="" />
                      }
                      checkedIcon={
                        <img src={RadioButtonChecked} height={25} alt="" />
                      }
                    />
                  }
                  label={
                    <div className="d-flex">
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                    </div>
                  }
                />
                <FormControlLabel
                  value={1}
                  checked={ratingDropdownOptions?.length === 1}
                  control={
                    <Radio
                      icon={
                        <img src={RadioButtonUnchecked} height={25} alt="" />
                      }
                      checkedIcon={
                        <img src={RadioButtonChecked} height={25} alt="" />
                      }
                    />
                  }
                  label={
                    <div className="d-flex">
                      <img src={StarIconGolden} alt="Rating Icon" height={25} />
                    </div>
                  }
                />
              </RadioGroup>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default RatingsFilterModal
